function waitForCheckoutButton() {
  const checkoutBtn = document.querySelector('button[name="checkout"], .cart__checkout-button, a[href="/checkout"]');
  const modal = document.getElementById('cartConfirmModal');
  const contentBox = document.getElementById('cartConfirmContent');
  const confirmBtn = document.getElementById('cartConfirmConfirm');
  const cancelBtn = document.getElementById('cartConfirmCancel');

  if (checkoutBtn && modal && contentBox && confirmBtn && cancelBtn) {
    checkoutBtn.addEventListener('click', function (e) {
      const cartItems = document.querySelectorAll('.cart-item, .cart__item, .cart-drawer-item');
      let shouldShowModal = false;
      let html = '';

      cartItems.forEach(item => {
        const title = item.querySelector('.text-current, .cart-item__name, .product-option__title')?.innerText?.trim() || '';
        const img = item.querySelector('img')?.src || '';
        const priceText = item.querySelector('.cart-item__selling-price, .price, .cart__item-price')?.innerText || '0';
        const quantity = parseInt(item.querySelector('input.cart-item__quantity-input, input[name^="updates"]')?.value || 1);

        // 检查是否包含 Lucky Pick
        if (title.includes('Lucky Pick!')) {
          shouldShowModal = true;
        }

        const price = parseFloat(priceText.replace(/[^\d.]/g, '')) || 0;
        const subtotal = (price * quantity).toFixed(2);
        const currency = priceText.replace(/[\d.,]/g, '').trim();

        // 变体信息处理
        const variantElements = item.querySelectorAll('.cart-item__variant');
        let variantPairs = [];
        variantElements.forEach(variant => {
          const label = variant.querySelector('.cart-item__variant-label')?.innerText.trim();
          const value = variant.querySelector('.cart-item__variant-value')?.innerText.trim();
          if (label && value) {
            variantPairs.push(`${label.replace(/:$/, '')}: ${value}`);
          }
        });
        const variantText = variantPairs.join(', ');

        html += `
          <div style="display: flex; margin-bottom: 16px; align-items: center;">
            <img src="${img}" alt="product" style="width: 60px; height: 60px; object-fit: cover; border-radius: 6px; margin-right: 12px;">
            <div style="flex: 1;">
              <div style="font-weight: bold;">${title}</div>
              ${variantText ? `<div style="font-size: 13px; color: #555;">${variantText}</div>` : ''}
              <div style="font-size: 13px; color: #555;">${currency}${price} x ${quantity} = <strong>${currency}${subtotal}</strong></div>
            </div>
          </div>
        `;
      });

      if (shouldShowModal) {
        e.preventDefault();
        contentBox.innerHTML = html || '<p>Your cart is empty.</p>';
        modal.style.display = 'block';
      } else {
        // 没有 Lucky Pick 商品就直接跳转
        window.location.href = '/checkout';
      }
    });

    cancelBtn.addEventListener('click', () => modal.style.display = 'none');
    confirmBtn.addEventListener('click', () => {
      modal.style.display = 'none';
      window.location.href = '/checkout';
    });

  } else {
    setTimeout(waitForCheckoutButton, 300);
  }
}

waitForCheckoutButton();
